export default "__VITE_ASSET__P6m6wodH__"